import styled, { css } from 'styled-components';

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  ${props => props.isFav && css`
    flex-direction: row !important;
  `};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-left: 0;
    flex-direction: column;
  };
`;

export const FirstEntryResult = styled.div`
  position: relative;
    ${props => props.theme.mediaQueries.small_phone}{
      font-size: 10px;
    };
`;

export const SecondEntryResult = styled.div`
  margin-top: 10px;
  position: relative;
    ${props => props.theme.mediaQueries.small_phone}{
      font-size: 10px;
    };
`;

export const TieBreakSup = styled.sup`
  margin-right: 5px;
  margin-left: -7px;
  position: absolute;
  top: -3px;
  font-size: 9px;
  ${props => props.color && css`
    color: ${props.theme.colors[props.color]};
  `};
  ${props => props.theme.mediaQueries.small_phone}{
      font-size: 8px;
      margin-left: -10px;
    };
  ${props => props.weight && css`
    font-weight: ${props.weight};
  `};
`;
